/* eslint-disable @typescript-eslint/no-unnecessary-condition */
const IS_DEV = typeof process !== "undefined" && process.env?.NODE_ENV !== "production";
const cacheDebugOn = () => {
    try {
        return (typeof window !== "undefined" &&
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- intentional runtime check
            window.__VNI_CACHE_DEBUG__ === true);
    }
    catch {
        return false;
    }
};
const qs = () => typeof window !== "undefined"
    ? new URLSearchParams(window.location.search)
    : new URLSearchParams();
export function isCacheDisabled() {
    if (qs().get("cache") === "off")
        return true;
    return IS_DEV && cacheDebugOn();
}
export function getCacheTTL(defaultMs) {
    const override = Number(qs().get("bars-ttl"));
    return Number.isFinite(override) && override > 0 ? override : defaultMs;
}
export function enforceMaxSize(map, maxEntries) {
    while (map.size > maxEntries) {
        const oldest = map.keys().next().value;
        if (oldest !== undefined)
            map.delete(oldest);
    }
}
